import { NavLink } from 'react-router';
import { cn } from '@/lib/utils';
import { navItems } from './navItems';

export function BottomNav() {
  return (
    <nav
      aria-label="Navegação principal"
      className="fixed inset-x-0 bottom-0 z-40 flex h-16 items-stretch justify-around border-t border-(--color-border) bg-(--color-surface) backdrop-blur-sm md:hidden"
    >
      {navItems.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center justify-center gap-1 text-xs transition-colors',
              isActive ? 'text-(--color-accent)' : 'text-(--color-fg-muted) hover:text-(--color-fg)',
            )
          }
        >
          <Icon className="h-5 w-5" aria-hidden />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
